/** Small circular progress indicator; shared by category cards and (formerly) OkrStats. */
export function ProgressRing({ value }: { value: number }) {
  const size = 40;
  const r = (size - 6) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (circ * Math.min(Math.max(value, 0), 100)) / 100;
  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }} className="flex-shrink-0">
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth={3}
        className="stroke-amber-100 dark:stroke-amber-950" />
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth={3}
        strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round"
        className="stroke-amber-500 transition-[stroke-dashoffset]" />
    </svg>
  );
}
